import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Admin, Login } from 'containers';
import styles from './styles';

class Root extends Component {
  render = () => {
    const { signedIn, loading, classes } = this.props;
    if (loading) {
      return (
        <div className={classes.loading}>
          <CircularProgress size={50} />
        </div>
      );
    } else {
      return signedIn ? <Admin /> : <Login />;
    }
  }
}

const mapStateToProps = (state) => {
  const signedIn = state.auth.getIn(['user', 'isSignedIn']);
  const loading = state.auth.getIn(['authenticate', 'loading']);
  return { signedIn, loading };
};

const component = connect(mapStateToProps)(Root);
export default withStyles(styles)(component);



// WEBPACK FOOTER //
// ./src/containers/Root/index.js